import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef} from '@angular/material/dialog';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import { ToastrService } from 'ngx-toastr';
import { MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import storageService from '@shared/storage/storageService';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.scss'],
})
export class AddUserComponent implements OnInit {
  
  public userForm: FormGroup;
  public submitted = false;
  data: any[];
  organizationList: any;
  getRoleName:any;
  userRoles : any;
  selectedValue = {id: -1};
  selectedOrg = '';
  loading: boolean = false;
  selectedValues = [];
  accountants: any[];
  addToaster :any;
  assignToaster :any;
  userId :any;
  selectedLanguage = "";

  @ViewChild('checkbox')
  public mulObj: MultiSelectComponent;
  @ViewChild('selectall')
  public checkboxObj: CheckBoxComponent;
  @ViewChild('dropdown')
  public dropdownObj: CheckBoxComponent;
  @ViewChild('select')
  public reorderObj: CheckBoxComponent;
  public mode: string;
  public selectedResult: any = [];
  

  public checkFields: Object = { text: 'name', value: 'accountantId' };
  public popHeight: string = '350px';
  successMsg: any;
  allSpecialties: any[];
  allSpecialization: any[];
  checkWaterMark: any;
  filterPlaceholder: any;
  allDepartments: any[];
  departments: any[];

  constructor(public dialogRef: MatDialogRef<AddUserComponent>,
    public fb: FormBuilder, public apiCall: ApiCall,
    private toastr: ToastrService,
    private broadCast: BroadCastServiceService,
		public translate: TranslateService
    ) {
     
    this.userForm = fb.group({
      firstName: ['', [Validators.required,Validators.maxLength(50)]],
      lastName: ['', [Validators.required,Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      contactNumber: ['', [Validators.required]],
      organizationId: ['',[Validators.required]],
      roles:['',[Validators.required]],
      assignAccountants: [''],
      useCompanyAddress: [true],
      city : [''],
      activitySector : [''],
      activity : [''],
      legalStatus : [''],
      turnover : [''],
      effective : [''],
      
    });
    this.userForm.reset();
  }

  getRole(obj) {
    let temp = [];
      temp.push(
        { name: obj.name, id: obj.id }
      );
    return temp;
  }

  ngOnInit() {
    this.setLanguage();
    this.mode = 'CheckBox';
    this.selectedResult = [];
    this.getOrganisationList();
    this.getUserRoles();
    this.userForm.get('email').valueChanges.subscribe((event) => {
    this.userForm.get('email').setValue(event.toLowerCase(), { emitEvent: false });
    })

    this.userForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      contactNumber: ['', [Validators.required]],
      roles:['',[Validators.required]],
      organizationId: [''],
      assignAccountants: [''],
      useCompanyAddress: [true],
      city : [''],
      activitySector : [''],
      activity : [''],
      legalStatus : [''],
      turnover : [''],
      effective : [''],
      clientOrganization:[''],
      grade : [''],
      department : ['']

    });
    this.getAllSpecializations();
    this.getAllDepartments();
  }

  setLanguage() {
		this.selectedLanguage = storageService.getItem("language");
		this.translate.use(this.selectedLanguage);
	}

  getOrganisationList() {
    this.apiCall.getOrganisationList().subscribe((res: any) => {
      this.data = res.data;
    })
  }

  getUserRoles() {
    this.apiCall.getUserRoles().subscribe((res: any) => {
      this.userRoles = res.data;
    })
  }

  get f(): { [key: string]: AbstractControl } {
    return this.userForm.controls;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
  saveData(): void {
    this.submitted = true;
    this.loading = true;
    if (!this.userForm.valid) {
      this.loading = false;
      return;
    }
    this.userForm.value.active = true
    if(this.userForm.value.roles){
      this.userForm.value.roles = this.getRole(this.userForm.value.roles);
    }
    if(this.userForm.value.organizationId){
    this.userForm.value.organizationId = this.userForm.value.organizationId.id;
    }
    let userSpecialization: any[] = [];
    if(this.selectedValue.id == 3) {
      let selectedSpeciality = this.prepareSpecialityObj(this.userForm.value.grade);
      selectedSpeciality.forEach(ele => {
      let data = this.allSpecialization.find(x => x.specializationType === ele)
        let tempData = {
          specialization : data.id,
          // userId : this.currentUser.id
        }
        userSpecialization.push(tempData);
      });
    }
    let requestBody = this.prepareSaveUserRequestBody(this.userForm.value,userSpecialization);
    this.apiCall.addUser(requestBody).subscribe((res: any) => {
      try {
            if(res.status == "SUCCESS"){
              this.dialogRef.close(false);
              this.broadCast.sendMessage("getUser");
              this.broadCast.sendMessage('organization');  
              this.userId = res.data.id;
              if(res.data.roles[0].id == 4) {
                let activty = {
                  activitySectorName : res.data.activitySector
                }
                // this.apiCall.addActivitySector(activty,this.userId).subscribe(res => {
                //   if(res.status == 'SUCCESS') {
                //   }
                // });
              }
              this.addToaster=res.message;
              this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.ADD_SUCCESS'])
              .subscribe(translations => {
                this.addToaster = translations['SUPER_ADMIN.USERS.ADD_USER.ADD_SUCCESS'];
              });
              // Assign accountants to the client
              this.assignAccountants(this.userForm.value.assignAccountants);
              } else {
                 let message;
                 if(res.message == 'Email address already exists.Please use different email address.') {
                  this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.EMAIL_ALREADY_EXIST'])
                  .subscribe(translations => {
                    message = translations['SUPER_ADMIN.USERS.ADD_USER.EMAIL_ALREADY_EXIST'];
                });   
                  this.toastr.error(message, '');
                 } else {
                  this.toastr.error(res.message, '');
                 }
              }
          } catch {
          this.toastr.success(res.message, '');
        }
    },(error) => {

    },() => {
      this.loading = false; 
    })
  }
  prepareSpecialityObj(speciality: any) {
    let specialtiesArray: any = [];
      this.allSpecialties.forEach(_element => {
        if (speciality == _element) {
          specialtiesArray.push(_element);
        }
    });
    return specialtiesArray;
  }

  prepareSaveUserRequestBody(formValue: any,userSpecialization) {
    try {
      return {
        ...formValue,
        userSpecializations : userSpecialization,
        fullName: formValue.firstName + " " + formValue.lastName
      };
    } catch (error) {
      console.error("Error while preparing the request body, ", error);
    }
  }

  assignAccountants(assignAccountants){
    if (assignAccountants.length > 0) {
      let accountantObj = this.preparedAssignAccountantRequestObject(assignAccountants);
      this.apiCall.assignAccountants(this.userId,accountantObj).subscribe((response) => {
          this.assignToaster=response.message;
          this.toastr.success(this.addToaster + ' and ' + this.assignToaster,'');
      },
       (err) => {
        this.toastr.error(this.assignToaster, '');
      });
    }else{
      this.toastr.success(this.addToaster,'');
    }
  }

  preparedAssignAccountantRequestObject(assignAccountants){
    let accountantArray = [];
    assignAccountants.forEach(id => {
      let accountantObj : any = {};
      accountantObj.accountantId = id;
      accountantArray.push(accountantObj);
    });
    return accountantArray;
  }
  
  keyPress(event: any) {
    const pattern = /[0-9 ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // alphabetKeyPress(event: any) {
  //   const inputField = event.target as HTMLInputElement;
  //   const pattern = /^[a-zA-Z\s!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]*$/;
  //   const inputChar = String.fromCharCode(event.charCode);
  //   if (event.keyCode !== 8 && !pattern.test(inputChar)) {
  //     event.preventDefault();
  //   }
  // }
  // onPaste(event: ClipboardEvent) {
  //   const clipboardData = event.clipboardData;
  //   const pastedData = clipboardData.getData('text/plain');
  //   const regex = /[0-9]/g;
  
  //   if (regex.test(pastedData)) {
  //     event.preventDefault(); 
  //   }
  // }
  preparedAccountantData(accountants){
    accountants.forEach(accountant => {
      accountant.name = accountant.firstName + ' ' + accountant.lastName;
      accountant.accountantId = accountant.id;
    });
    return accountants;
  }
  getAccountants() {
    try {
      let selectedOrganizationId = this.userForm.get("organizationId").value.id;
      if (selectedOrganizationId !== "" && selectedOrganizationId !== null) {
        this.apiCall.getAccountants(selectedOrganizationId).subscribe((response) => {
          this.accountants = this.preparedAccountantData(response.data);
        }, (err) => {
          console.log(err);
        });
      }
    } catch (exception) {
      console.error("Error ocurred while getting the accountants");
    }
  }

  getAllSpecializations() {
    try {
      this.allSpecialties = [];
      this.allSpecialization = [];
      this.apiCall.getSpecializations().subscribe((res) => {
        this.allSpecialization = res.data;
          res.data.forEach(element => {
             this.allSpecialties.push(element.specializationType);
          });
        this.translate.get(['CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_1', 'CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_2', 'CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_3', 'CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_4', 'CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_5','CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SELECT_SPECIALTY','CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SEARCH_SPECIALTY'])
          .subscribe(translations => {
            this.checkWaterMark = translations['CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SELECT_SPECIALTY'];
            this.filterPlaceholder = translations['CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SEARCH_SPECIALTY'];
        },(err) => {
          console.log(err);
        });

      }, (error) => {
        console.error("Error while getting specialties : ", error);
      });
    } catch (error) {
      console.error("Error : ", error);
    }
  }

  getAllDepartments() {
    try {
      this.allDepartments = [];
      this.departments = [];
      this.apiCall.getDepartments().subscribe((res) => {
        this.allDepartments = res.data;
          res.data.forEach(element => {
             this.departments.push(element.departmentName);
          });

      }
      , (error) => {
        console.error("Error while getting department : ", error);
      });
    } catch (error) {
      console.error("Error : ", error);
    }
  }
}
